import shortUuid from 'short-uuid'

export default (): Promise<string> => {
  const uuid = shortUuid.uuid()
  const id = shortUuid().fromUUID(uuid)
  return Promise.resolve(id)
}
